var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-bottom-sheet',{ref:"methodSheet",attrs:{"background-clickable":false,"background-scrollable":false,"click-to-close":_vm.canSwipe,"is-full-screen":true,"maxHeight":'65%',"maxWidth":'95%',"overlay":true,"rounded":true,"swipe-able":_vm.canSwipe}},[_c('PaymentMethods',{attrs:{"set-swipe":_vm.setSwipe}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }